import { zodResolver } from "@hookform/resolvers/zod"
import { useEffect, useState } from "react"
import { useForm, UseFormProps } from "react-hook-form"
import { ZodSchema } from "zod"

export interface UseAppFormProps<T> extends Omit<UseFormProps<T>, "resolver"> {
  schema?: ZodSchema<T>
}

export default function useAppForm<T>(props: UseAppFormProps<T>) {
  const { schema, ...formProps } = props
  const reactHookForm = useForm<T>({
    ...formProps,
    resolver: zodResolver(schema),
  })

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (reactHookForm.formState.isDirty) {
        e.preventDefault()
        e.returnValue = ""
        alert("You have unsaved changes. Are you sure you want to leave?")
      }
    }
    window.addEventListener("beforeunload", handleBeforeUnload)
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload)
    }
  }, [reactHookForm.formState.isDirty])

  return reactHookForm
}
